import React from 'react';
import { Box } from '@mui/material';
import BasicDetails from './BasicDetails';
import AdditionalDetails from './AdditionalDetails';
import BudgetDetails from './BudgetDetails';

const PositionDetails = ({ form }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <BasicDetails form={form} />
            <BudgetDetails form={form} />
            <AdditionalDetails form={form} />
        </Box>
    );
};

export default PositionDetails;
